import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';
import { Observable } from 'rxjs';
import {  HttpClient,HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HrmsService {
  saveCategory(payload: { name: string | null | undefined; description: string; createdBy: string; updatedBy: string; }) {
    throw new Error('Method not implemented.');
  }
  baseUrl: any;
  // http: any;
  triggerFeedRefresh: any;
  feedRefresh$: any;

  constructor(private httpClientService: HttpClientService, private http: HttpClient ) { }

  public createEmployee(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_EMPLOYEE, data);
  }

  public getEmployees(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_EMPLOYEE, data);
  }

  public getEmployeeByID(data: any) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_EMPLOYEE_BYID}?id=${data}`);
  }

  public updateEmployee(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_EMPLOYEE, data);
  }

  public deleteEmployee(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.DELETE_EMPLOYEE, data);
  }

  public autoSearchEmployee(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.AUTOSEARCHEMPLOYEE}?searchText=${searchKey}`);
  }

  // Employee Shift

  public createEmployeeShift(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_EMPLOYEE_SHIFT, data);
  }

  public getShift(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_SHIFT, data);
  }

  public getShiftById(data: any) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_SHIFT_BYID}?id=${data}`);
  }

  public updateShift(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_SHIFT, data);
  }

  public deleteShift(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.DELETE_SHIFT, data);
  }

  public autoSearchShift(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.AUTOSEARCHSHIFT}?searchText=${searchKey}`);
  }

  // Employee Attendance

  public createAttendance(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_EMPLOYEE_ATTENDANCE, data);
  }

  public getAttendance(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_EMPLOYEE_ATTENDANCE, data);
  }

  public getAttendanceEmpById(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_EMPLOYEE_ATTENDANCE_BYID, data);
  }

  public updateAttendance(data: any, _payload?: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_ATTENDANCE, data);
  }

  // Leave Management

  public createLeave(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_EMPLOYEE_LEAVE, data);
  }

  public getLeave(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_EMPLOYEE_LEAVE, data);
  }

  public updateLeave(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_LEAVE, data);
  }

  public deleteLeave(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.DELETE_LEAVE, data);
  }

  public autoSearchLeave(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.AUTOSEARCHLEAVE}?searchText=${searchKey}`);
  }

  public getLeaveById(data: any) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_LEAVE_BYID}?id=${data}`);
  }

  public getLeaveSummary(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_LEAVE_SUMMURY, data);
  }

  public applyLeaveEmail(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.SEND_MAIL, data);
  }

  public reviewLeaveEmail(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.REVIEWED_LEAVE_REQUEST, data);
  }

  public getLeaveBalance(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_LEAVE_BALANCE, data);
  }

  // Employee Designation

  public getDesignation(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_EMPLOYEE_DESIGNATION, data);
  }

  // Leave Type

  public getLeaveType(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_LEAVE_TYPES, data);
  }


  // leave reasons

  public getLeaveReasons(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_LEAVE_REASONS, data);
  }

  // Location Management

  public createLocation(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_LOCATION, data);
  }

  public getLocations(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_LOCATION, data);
  }

  public getLocationById(id: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_LOCATION_BYID}?id=${id}`);
  }

  public updateLocation(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_LOCATION, data);
  }

  public deleteLocation(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.DELETE_LOCATION, data);
  }

  public autoSearchLocation(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.AUTOSEARCHLOCATION}?searchText=${searchKey}`);
  }

  // Employee ↔ Location Assignment

  public assignLocationToEmployee(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.ASSIGN_LOCATION_TO_EMPLOYEE, data);
  }

  public getEmployeeLocations(empId: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_EMPLOYEE_LOCATIONS}?empId=${empId}`);
  }

  // Geofence Check-In / Check-Out

  public locationCheckIn(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.LOCATION_CHECKIN, data);
  }

  public locationCheckOut(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.LOCATION_CHECKOUT, data);
  }

  // Attendance Approval

  public getPendingApprovals() {
    return this.httpClientService.get(CONFIG.EMPLOYEE.GET_PENDING_APPROVALS);
  }

  public approveAttendance(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.APPROVE_ATTENDANCE, data);
  }


  // =========================
  // CREATE ONBOARDING
  // =========================
  createOnboarding(payload: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ONBOARDING.SAVE, payload);
  }

  getOnboardings(pageIndex: number, pageSize: number): Observable<any> {
    return this.httpClientService.post(CONFIG.ONBOARDING.GET_ALL, { pageIndex, pageSize });
  }

  getOnboardingById(id: number): Observable<any> {
    return this.httpClientService.get(`${CONFIG.ONBOARDING.GET_BY_ID}?id=${id}`);
  }

  updateOnboarding(payload: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ONBOARDING.UPDATE, payload);
  }

deleteOnboard(id: number): Observable<any> {
  return this.httpClientService.post(CONFIG.ONBOARDING.DELETE, id);
}

  updateStatus(payload: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ONBOARDING.STATUS, payload);
  }

  searchOnboardings(searchText: string): Observable<any> {
    return this.httpClientService.get(`${CONFIG.ONBOARDING.SEARCH}?searchText=${searchText}`);
  }

  uploadOnboardingResume(
  file: File,
  onboardingId: number,
  updatedBy?: string,
  fileName?: string
): Observable<any> {
  const formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('onboardingId', onboardingId.toString());

  if (updatedBy) {
    formData.append('updatedBy', updatedBy);
  }

  if (fileName) {
    formData.append('fileName', fileName);
  }

  return this.httpClientService.post(CONFIG.ONBOARDING.UPLOAD_RESUME, formData);
}



  // Employee list
  public getOnboardingEmployees(): Observable<any> {
    return this.httpClientService.get(
      CONFIG.EMPLOYEE.GET_ALL_EMPLOYEES
    );
  }

  // Offboarding
  public createOffboarding(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.CREATE_OFFBOARDING, data);
  }


  public getOffboardingEmployees() {
    return this.httpClientService.get(CONFIG.EMPLOYEE.GET_OFFBOARDING);
  }

  public getOffboardingById(id: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_OFFBOARDING_BY_ID}/${id}`);
  }
  public updateOffboarding(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_OFFBOARDING, data);
  }
  public deleteOffboarding(id: number) {
    return this.httpClientService.deleteWithBody(CONFIG.EMPLOYEE.DELETE_OFFBOARDING, [id]);
  }
  public autoSearchOffboarding(searchKey: string) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.SEARCH_OFFBOARDING}?searchText=${searchKey}`);
  }
  // Onboarding
  public getOnboardingList(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.GET_ONBOARDING, data);
  }

  // ===== Knowledge Transfer =====

  public saveKnowledgeTransfer(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.SAVE_KNOWLEDGE_TRANSFER, data);
  }

  public getKnowledgeTransfer(offboardingId: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_KNOWLEDGE_TRANSFER}/${offboardingId}`);
  }

  public updateKnowledgeTransfer(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.UPDATE_KNOWLEDGE_TRANSFER, data);
  }

  public deleteKnowledgeTransfer(id: number) {
    return this.httpClientService.deleteWithBody(CONFIG.EMPLOYEE.DELETE_KNOWLEDGE_TRANSFER, [id]);
  }
  //ExitInterview

  public saveExitInterview(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.SAVE_EXIT_INTERVIEW, data);
  }

  public getExitInterview(offboardingId: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_EXIT_INTERVIEW}/${offboardingId}`);
  }
  //Exitclosure
  public saveExitClosure(data: any) {
    return this.httpClientService.post(CONFIG.EMPLOYEE.SAVE_EXIT_CLOSURE, data
    );
  }

  public getExitClosure(offboardingId: number) {
    return this.httpClientService.get(`${CONFIG.EMPLOYEE.GET_EXIT_CLOSURE}/${offboardingId}`
    );
  }


  // =========================
  // ANNOUNCEMENT
  // =========================

  public createAnnouncement(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ANNOUNCEMENT.CREATE_ANNOUNCEMENT, data);
  }


  public getAnnouncements(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ANNOUNCEMENT.GET_ANNOUNCEMENT, data);
  }


  public getAnnouncementById(id: number): Observable<any> {
    return this.httpClientService.get(`${CONFIG.ANNOUNCEMENT.GET_ANNOUNCEMENT_BYID}/${id}`);
  }

  public updateAnnouncement(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ANNOUNCEMENT.UPDATE_ANNOUNCEMENT, data);
  }


  public deleteAnnouncement(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.ANNOUNCEMENT.DELETE_ANNOUNCEMENT, data);
  }

  public autoSearchAnnouncement(searchKey: string): Observable<any> {
    return this.httpClientService.get(`${CONFIG.ANNOUNCEMENT.AUTOSEARCH_ANNOUNCEMENT}?searchText=${searchKey}`);
  }


  public uploadAnnouncementAttachment(formData: FormData): Observable<any> {
    return this.httpClientService.post(CONFIG.ANNOUNCEMENT.UPLOAD_ATTACHMENT, formData);
  }



  public createSurvey(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY.CREATE_SURVEY, data);
  }

  public getSurveys(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY.GET_SURVEYS, data);
  }

  public getSurveyById(id: number): Observable<any> {
    return this.httpClientService.get(`${CONFIG.SURVEY.GET_SURVEY_BYID}/${id}`);
  }

  public updateSurvey(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY.UPDATE_SURVEY, data);
  }

  public deleteSurvey(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY.DELETE_SURVEY, data);
  }

  public autoSearchSurvey(searchKey: string): Observable<any> {
    return this.httpClientService.get(`${CONFIG.SURVEY.AUTOSEARCH_SURVEY}?searchText=${searchKey}`);
  }




  public createHoliday(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.HOLIDAY.CREATE_HOLIDAY, data);
  }

  public getHolidays(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.HOLIDAY.GET_HOLIDAYS, data);
  }

  public getHolidayById(id: number): Observable<any> {
    return this.httpClientService.get(`${CONFIG.HOLIDAY.GET_HOLIDAY_BYID}/${id}`);
  }

  public updateHoliday(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.HOLIDAY.UPDATE_HOLIDAY, data);
  }

  public deleteHoliday(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.HOLIDAY.DELETE_HOLIDAY, data);
  }

  public autoSearchHoliday(searchKey: string): Observable<any> {
    return this.httpClientService.get(`${CONFIG.HOLIDAY.AUTOSEARCH_HOLIDAY}?searchText=${searchKey}`);
  }



  public createSurveyQuestion(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY_QUESTION.CREATE_SURVEY_QUESTION, data);
  }

  getSurveyQuestions(surveyId: number, payload: any) {
    return this.httpClientService.post(
      `${CONFIG.SURVEY_QUESTION.GET_SURVEY_QUESTIONS}/${surveyId}`,
      payload
    );
  }

  getAllSurveyQuestions(): Observable<any> {
    return this.httpClientService.get(CONFIG.SURVEY_QUESTION.GET_ALL_SURVEY_QUESTIONS);
  }

  getSurveyQuestionById(surveyId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/GetSurveyQuestionById/${surveyId}`);
  }

  public updateSurveyQuestion(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY_QUESTION.UPDATE_SURVEY_QUESTION, data);
  }

  public deleteSurveyQuestion(data: any): Observable<any> {
    return this.httpClientService.post(CONFIG.SURVEY_QUESTION.DELETE_SURVEY_QUESTION, data);
  }

  public autoSearchSurveyQuestion(surveyId: number, searchKey: string): Observable<any> {
    return this.httpClientService.get(
      `${CONFIG.SURVEY_QUESTION.AUTOSEARCH_SURVEY_QUESTION}?surveyId=${surveyId}&searchText=${searchKey}`
    );
  }

  // CREATE EXPENSE
  public createExpenseReimbursement(data: any): Observable<any> {
    return this.httpClientService.post(
      CONFIG.EMPLOYEE.CREATE_EXPENSE_REIMBURSEMENT,
      data
    );
  }

  public getExpenseReimbursement(data: any): Observable<any> {
    return this.httpClientService.post(
      CONFIG.EMPLOYEE.GET_EXPENSE_REIMBURSEMENT,
      data
    );
  }

  public getExpenseReimbursementById(id: number): Observable<any> {
    return this.httpClientService.get(
      `${CONFIG.EMPLOYEE.GET_EXPENSE_REIMBURSEMENT_BY_ID}/${id}`
    );
  }

  public updateExpenseReimbursement(data: any): Observable<any> {
    return this.httpClientService.post(
      CONFIG.EMPLOYEE.UPDATE_EXPENSE_REIMBURSEMENT,
      data
    );
  }

  public deleteExpenseReimbursement(ids: any): Observable<any> {
    return this.httpClientService.deleteWithBody(
      CONFIG.EMPLOYEE.DELETE_EXPENSE_REIMBURSEMENT,
      ids
    );
  }

  public searchExpenseReimbursement(searchText: string): Observable<any> {
    return this.httpClientService.get(
      `${CONFIG.EMPLOYEE.SEARCH_EXPENSE_REIMBURSEMENT}?searchText=${searchText}`
    );
  }



  //FILES [shared files tab] 

public getFiles(): Observable<any> {
  return this.httpClientService.get(CONFIG.FILES.GET_FILES);
}

public deleteFile(ids: number[]): Observable<any> {
  return this.httpClientService.post(CONFIG.FILES.DELETE_FILE, ids);
}

public uploadAndSaveFile(formData: FormData): Observable<any> {
  return this.httpClientService.post(CONFIG.FILES.UPLOAD_AND_SAVE_FILE, formData);
}

public getFilesByEmployee(employeeId: number): Observable<any> {
  return this.httpClientService.get(
    CONFIG.FILES.GET_FILES_BY_EMPLOYEE,
    new HttpParams().set('employeeId', employeeId)
  );
}

public downloadFile(id: number): Observable<Blob> {
  return this.http.get(`${CONFIG.FILES.DOWNLOAD_FILE}/${id}`, {
    responseType: 'blob'
  });
}
public downloadAttachment(id: number): Observable<Blob> {
  return this.http.get(`${CONFIG.ANNOUNCEMENT_FILES.DOWNLOAD_ATTACHMENT}/${id}`, {
    responseType: 'blob'
  });


}


//HR DOCUMENT FILES
public uploadHrFile(formData: FormData): Observable<any> {
  return this.httpClientService.post(CONFIG.HR_DOCUMENT_FILES.UPLOAD_HR_FILE, formData);
}

public downloadSharedHrFile(id: number): Observable<Blob> {
  return this.http.get(`${CONFIG.HR_DOCUMENT_FILES.DOWNLOAD_SHARED_HR_FILE}/${id}`, {
    responseType: 'blob'
  });
}

public uploadAndSaveHrFile(formData: FormData): Observable<any> {
  return this.httpClientService.post(CONFIG.HR_DOCUMENT_FILES.UPLOAD_AND_SAVE_HR_FILE, formData);
}

public getSharedHrFiles(): Observable<any> {
  return this.httpClientService.get(CONFIG.HR_DOCUMENT_FILES.GET_SHARED_HR_FILES);
}

public linkHrFile(payload: any): Observable<any> {
  return this.httpClientService.post(CONFIG.HR_DOCUMENT_FILES.LINK_HR_FILE, payload);
}
  
public deleteSharedHrFile(ids: number[]): Observable<any> {
  return this.httpClientService.post(CONFIG.HR_DOCUMENT_FILES.DELETE_SHARED_HR_FILE, ids);
}

public getHrFilesByEmployee(employeeId: number): Observable<any> {
  return this.httpClientService.get(`${CONFIG.HR_DOCUMENT_FILES.GET_HR_FILES_BY_EMPLOYEE}?employeeId=${employeeId}`);
}



//ASSETS 
 
public getAssets(): Observable<any> {
  return this.httpClientService.get(CONFIG.ASSETS.GET_ASSETS);
}
 
public getAssetById(id: number): Observable<any> {
  return this.httpClientService.get(
    CONFIG.ASSETS.GET_ASSET_BY_ID,
    new HttpParams().set('id', id)
  );
}
 
public getAssetsByCategory(categoryId: number): Observable<any> {
  return this.httpClientService.get(
    CONFIG.ASSETS.GET_ASSETS_BY_CATEGORY,
    new HttpParams().set('categoryId', categoryId)
  );
}
 
public saveAsset(asset: any): Observable<any> {
  return this.httpClientService.post(CONFIG.ASSETS.SAVE_ASSET, asset);
}
 
public updateAsset(asset: any): Observable<any> {
  return this.httpClientService.post(CONFIG.ASSETS.UPDATE_ASSET, asset);
}
 
public deleteAssets(ids: number[]): Observable<any> {
  return this.httpClientService.post(CONFIG.ASSETS.DELETE_ASSETS, ids);
}
 
public getCategories(): Observable<any> {
  return this.httpClientService.get(CONFIG.ASSET_CATEGORIES.GET_CATEGORIES);
}
 
public saveCategorys(category: any): Observable<any> {
  return this.httpClientService.post(CONFIG.ASSET_CATEGORIES.SAVE_CATEGORY, category);
}

public updateCategory(category: any): Observable<any> {
  return this.httpClientService.post(CONFIG.ASSET_CATEGORIES.UPDATE_CATEGORY, category);
}
 

// percentage 
public getAssetCategoryPercentages(): Observable<any> {
  return this.httpClientService.get(CONFIG.ASSET_CATEGORIES.GET_PERCENTAGES);
}


// total number of the status 
public getAssetStatusCounts(): Observable<any> {
  return this.httpClientService.get(CONFIG.ASSET_CATEGORIES.GET_STATUS_COUNTS);
}

}
  

